var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"helpPage"},[_c('Top',{attrs:{"depth1":_vm.depth1,"depth2":_vm.depth2}}),_c('router-view',{attrs:{"depth1":_vm.depth1,"depth2":_vm.depth2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }